export const ITEMS = [
  {
    title: 'Home',
    path: '/home',
  },
  {
    title: "About",
    path: "/about",
  },
  {
    title: "Wall",
    path: "/wall",
  },
];